import { FC, useEffect, useRef } from "react";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";
import { InformationPopup } from "../../SharedComponents/InformationPopup";
import { Table } from "@sainsburys-tech/luna-table";
import { UI_CONSTANTS } from "../../../Constants/constants";
import {
  ArrayEmptyOrNullOrBlanckSpaceRemover,
  IsNullEmptyOrUndefined,
} from "../../../helpers/StringHelpersMethods";
import { useSelector } from "react-redux";

const ProductQuery: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);
  const columnDefinition: IColumn[] = [
    {
      name: "Item Number",
      accessor: "SainId",
    },
    {
      name: "Display Item Number",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SkuNumber ? rowData?.SkuNumber : rowData?.CatNumber,
        };
      },
    },
    {
      name: "Family Group",
      accessor: "FamilyGroup",
      type: "family-group",
    },
    {
      name: "Family Group Description",
      accessor: "FamilyGroupDescription",
    },
    {
      name: "TUC",
      accessor: (rowData: any) => {
        return {
          value: rowData?.TUC,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: string; row: any }) => {
        const tucValues = ArrayEmptyOrNullOrBlanckSpaceRemover(value);
        return tucValues?.length > 1 ? (
          <div>
            <InformationPopup
              linkText={UI_CONSTANTS.MULTI}
              modalHeading={row.SainId}
              initialValue={tucValues[0]}
            >
              <Table
                data={tucValues}
                columns={[
                  {
                    name: "TUC",
                    accessor: (rowData: any) => ({
                      value: rowData,
                    }),
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : tucValues?.length == 0 ? (
          "--"
        ) : (
          tucValues
        );
      },
    },
    {
      name: "EAN",
      accessor: (rowData: any) => {
        return {
          value: rowData?.EAN,
          row: rowData,
        };
      },
      renderFunc: ({ value, row }: { value: string; row: any }) => {
        return value?.split(",").length > 1 ? (
          <div>
            <InformationPopup
              linkText={UI_CONSTANTS.MULTI}
              modalHeading={row.SainId}
              initialValue={value?.split(",")[0]}
            >
              <Table
                data={value?.split(",")}
                columns={[
                  {
                    name: "EAN",
                    accessor: (rowData: any) => ({
                      value: rowData,
                    }),
                  },
                ]}
              />
            </InformationPopup>
          </div>
        ) : IsNullEmptyOrUndefined(value) ? (
          "--"
        ) : (
          value
        );
      },
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: "Product Group",
      accessor: "ProductType",
    },
    {
      name: "UOM",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_SKU ||
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_PACK
              ? `CS${rowData?.PackSize}`
              : rowData?.Alias === UI_CONSTANTS.ARGOS
              ? (rowData?.PackSize == 1) ? `EA` : `CS${rowData?.PackSize}`
              : rowData?.PackSize,
        };
      },
    },
    {
      name: "New Product",
      accessor: "NewLine",
      type: "tick",
    },
    {
      name: "Break Pack Indicator",
      customClass: "customColBoolean",
      type: "tick",
      accessor: (rowData: any) => {
        return {
          value: rowData?.DimensionData?.BreakPackIndicator,
          row: rowData,
        };
      },
    },
    {
      name: "Created Date",
      accessor: "CreatedDate",

      customClass: { td: "no-wrap" },
    },
    {
      name: "Last Updated Date",
      accessor: "UpdatedDate",

      customClass: { td: "no-wrap" },
    },
    {
      name: "Last Updated By",
      accessor: "UpdatedBy",
    },
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.searchProductData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default ProductQuery;
